<script setup lang="ts">
import { computed } from 'vue';
import { useInternational } from '@/common/locale';
import KeyboardShortcutGuide from '@/common/components/molecules/keyboardShortcutGuide/KeyboardShortcutGuide.vue';
import KeyboardShortcutItem from '@/common/components/molecules/keyboardShortcutGuide/KeyboardShortcutItem.vue';
import type { ShortcutData } from '@/common/components/molecules/keyboardShortcutGuide/keyboardShortcutGuide.type';

interface Emits {
  (e: 'close'): void;
}

const emit = defineEmits<Emits>();

const { t } = useInternational();

const guideItems = computed<ShortcutData[]>(() => [
  {
    items: ['up', 'down'],
    desc: t('WORD.TO_NAVIGATE'),
  },
  {
    items: ['enter'],
    desc: t('WORD.TO_SELECT'),
  },
]);

const escItem = computed<ShortcutData>(() => ({
  items: ['esc'],
  desc: t('WORD.TO_CLOSE'),
}));
</script>

<template>
  <footer class="menu-search-footer">
    <h-stack
      align="center"
      justify="space-between"
    >
      <keyboard-shortcut-guide :items="guideItems" />
      <keyboard-shortcut-item
        class="menu-search-footer__close"
        :data="escItem"
        @click.stop="emit('close')"
      />
    </h-stack>
  </footer>
</template>

<style lang="scss">
.menu-search-footer {
  max-height: 34px;
  padding: 8px 12px 0;
  border-top: 1px solid var(--color-gray-05-03);

  &__close {
    cursor: pointer;
  }
}
</style>
